// @ts-check
import { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CarouselContext } from 'pure-react-carousel';

/**
 * @typedef {object} Props
 * @property {(currentSlide: number) => unknown} onChange Slide index change
 * handler
 */

/**
 * Allow carousel consumers to subscribe to context changes by providing a
 * callback
 * @param {Props} props
 */
const CarouselChangeHandler = ({
  onChange,
}) => {
  const carouselContext = useContext(CarouselContext);
  useEffect(() => {
    const handler = () => onChange(carouselContext.state.currentSlide);
    carouselContext.subscribe(handler);
    return () => carouselContext.unsubscribe(handler);
  }, [onChange, carouselContext]);
  return null;
};

CarouselChangeHandler.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default CarouselChangeHandler;
